import View from './Homepage'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
  viewport: state.viewport.viewport,
  isTruvidInitialized: state.truvid.initialized,
})

const Homepage = connect(mapStateToProps)(View)

export default Homepage
